import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import withUser from "../hoc/withUser";
import AddCustomer from "../components/AddCustomer";
import { Route } from "react-router-dom";

class AddCustomerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deals: [],
      isLoading: true,
      organisations: [],
      selectedCustomer: []
    };
  }
  componentWillMount() {
    this.fetchOrganisations();
    this.fetchSelectedCustomer();
  }
  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.organisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false });
      });
  };
  fetchSelectedCustomer = () => {
    if (this.props.match.params.customerId !== undefined) {
      const selectedCustomer = [];
      let customerRef = this.props.db
        .collection("customers")
        .doc(this.props.match.params.customerId);
      let getDoc = customerRef
        .get()
        .then(doc => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            const singleCustomer = doc.data();
            singleCustomer.id = doc.id;
            selectedCustomer.push(singleCustomer);
            this.setState({ selectedCustomer }, () => {
              console.log(this.state.selectedCustomer);
            });
          }
        })
        .catch(err => {
          console.log("Error getting document", err);
        });
    }
  };
  addCustomer = customer => {
    this.props.db.collection("customers").add(customer);
  };
  updateCustomer = (
    selectedCustomerId,
    name,
    email,
    phoneNumber,
    panNumber,
    gstNumber,
    tinNumber,
    address,
    imageURL
  ) => {
    this.props.db
      .collection("customers")
      .doc(selectedCustomerId)
      .update({
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        panNumber: panNumber,
        gstNumber: gstNumber,
        tinNumber: tinNumber,
        address: address,
        imageURL: imageURL
      });
  };

  render() {
    const { user } = this.props;
    const { organisations, selectedCustomer } = this.state;
    return (
      <div>
        <Route
          exact
          path="/addCustomer/:uid"
          render={props => (
            <AddCustomer
              addCustomer={this.addCustomer}
              user={user}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
              operation={"addCustomer"}
              selectedCustomer={selectedCustomer}
              updateCustomer={this.updateCustomer}
            />
          )}
        />
        <Route
          exact
          path="/updateCustomer/:customerId"
          render={props => (
            <AddCustomer
              addCustomer={this.addCustomer}
              user={user}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
              operation={"updateCustomer"}
              selectedCustomer={selectedCustomer}
              updateCustomer={this.updateCustomer}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(AddCustomerContainer)));
